import env from "@/env.mjs";
import { CentraProduct, CentraProductServer } from "@/lib/centra/atomicSetup";
import formatProduct from "@/lib/centra/formatters/formatProduct";
import { useCart } from "@/lib/hooks/useSelection";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ofetch } from "ofetch";
export const useCartPreOrder = () => {
  const { cart } = useCart();
  const ids = cart?.items?.map(item => item?.displayItemId) ?? [];
  const { data: products, isLoading } = useProducts({ ids });

  if (!products || products.length === 0) {
    return {
      orderType: "standard",
      isLoading,
      preOrderIds: [] as string[],
    };
  }

  const isPreorderProduct = (
    product: unknown,
  ): product is { data: { preorder: string; itemId: string } } => {
    return (
      typeof product === "object" &&
      product !== null &&
      "data" in product &&
      typeof (product as any).data?.preorder === "string" &&
      typeof (product as any).data?.itemId === "string"
    );
  };

  const preOrderIds = products
    .filter(product => {
      return isPreorderProduct(product) && product.data.preorder === "1";
    })
    .map(product => (isPreorderProduct(product) ? product.data.itemId : ""))
    .filter(Boolean);

  const preOrderCount = preOrderIds.length;
  const totalProductCount = products.length;

  let orderType = "standard";
  if (preOrderCount > 0) {
    orderType = preOrderCount === totalProductCount ? "preorder" : "mixed";
  }

  return {
    orderType,
    isLoading,
    preOrderIds,
  };
};

export const useProducts = ({ ids }: { ids: (string | undefined)[] }) => {
  return useQuery({
    queryKey: ["products", ids],
    queryFn: async () => {
      if (!ids) return [];
      const products = await ofetch(
        env.NEXT_PUBLIC_CENTRA_CHECKOUT_API + "/products",
        {
          method: "POST",
          body: JSON.stringify({
            products: ids,
          }),
        },
      );

      const formattedProducts = products?.products?.map(
        (product: CentraProductServer) => {
          return formatProduct(product);
        },
      );

      return formattedProducts as CentraProduct[];
    },
    enabled: !!ids?.length,
    placeholderData: keepPreviousData,
  });
};
